import { SimpleSearchFilter } from 'api/dashboard/widget';
import { DayOfWeek } from 'core/day-of-week';
import {
  BaseTemplate,
  TemplateObjectType,
  TemplateId,
  TemplateMeta,
} from 'data/templates/api';

export enum FrequencyType {
  Week = 'WEEK',
  Month = 'MONTH',
}

export type Frequency = {
  type: {
    label: string;
    value: FrequencyType;
  };
  interval: {
    label: number;
    value: number;
  };
  onDay: {
    label: string;
    value: string;
  };
  onMonthDay: {
    label: number;
    value: number;
  };
  onTime: {
    label: string | number;
    value: string | number;
  };
};

export enum ProjectTargets {
  All = 'all_projects',
  Filtered = 'filtered_projects',
}

export enum StatusUpdatesFilterTypes {
  All = 'all',
  Any = 'any',
}

export interface StatusUpdateTemplate extends BaseTemplate {
  objectType: TemplateObjectType.StatusUpdates;
  templateId: TemplateId;
  templateName: string;
  enableAutoPublish?: boolean;
  private?: boolean;
  templateMeta?: TemplateMeta;
}

export interface StatusUpdateTemplateDetails
  extends Omit<StatusUpdateTemplate, 'enableAutoPublish'> {
  templateContent: {
    content: string;
    enableAutoPublish: boolean;
    private: boolean;
    criteria: {
      timeFrame: FrequencyType;
      week: {
        frequency: number;
        days: DayOfWeek[];
      };
      month: {
        frequency: number;
        day: number;
      };
      time: string;
    };
    filters: SimpleSearchFilter | null;
  };
}

export interface NewStatusUpdateTemplate
  extends Omit<StatusUpdateTemplate, 'templateId'> {
  templateId: TemplateId;
}
